// extracted by mini-css-extract-plugin
module.exports = {"statusLabel":"bEv7a"};